module.exports = __webpack_public_path__ + "static/media/privacy_banner.78334271.svg";